// components/AssetLogDrawer.tsx
import React from 'react';
import {Drawer,Timeline,Typography,Spin,Collapse,Tag,Divider,Space,Descriptions,} from 'antd';
import {ClockCircleOutlined,EditOutlined,DeleteOutlined,PlusCircleOutlined,} from '@ant-design/icons';
import { useAppConfig } from '../../../customhooks/useAppConfig';

const { Title, Text } = Typography;
const { Panel } = Collapse;

const safeParseJson = (value: any) => {
    try {
        if (typeof value === 'object') {
            return value;
        }

        const parsed = JSON.parse(value);

        if (typeof parsed === 'string') {
            return JSON.parse(parsed);
        }

        return parsed;
    } catch (error) {
        return value; 
    }
};


interface AssetLogDrawerProps {
    open: boolean;
    onClose: () => void;
    assetId: number | null;
    assetLogs: any[];
    loading: boolean;
}

const getIcon = (action: string) => {
    const baseStyle = {
        fontSize: 18,
        padding: 6,
        borderRadius: '50%',
        backgroundColor: '#fff',
        border: '1px solid #d9d9d9',
    };

    switch (action) {
        case 'created':
            return <PlusCircleOutlined style={{ ...baseStyle, color: '#52c41a' }} />;
        case 'updated':
            return <EditOutlined style={{ ...baseStyle, color: '#1890ff' }} />;
        case 'deleted':
            return <DeleteOutlined style={{ ...baseStyle, color: '#ff4d4f' }} />;
        default:
            return <ClockCircleOutlined style={baseStyle} />;
    }
};

const AssetLogDrawer: React.FC<AssetLogDrawerProps> = ({open,onClose,assetId,assetLogs,loading,}) => {
    const config = useAppConfig();
      if (!config) return null;
    
    return (
        <Drawer
            title={
                <div style={{ fontSize: 20, fontWeight: 600 }}>
                    Asset Log Timeline - ID: {assetId}
                </div>
            }
            placement="right"
            width={560}
            onClose={onClose}
            open={open}
            bodyStyle={{ overflowY: 'auto', padding: 24, backgroundColor: '#fafafa' }}
        >
            {loading ? (
                <div style={{ textAlign: 'center', marginTop: 50 }}>
                    <Spin size="large" />
                </div>
            ) : (
                <Timeline>
                    {assetLogs
                        .filter((log) => log.asset_id === assetId)
                        .sort(
                            (a, b) =>
                                new Date(b.created_at).getTime() -
                                new Date(a.created_at).getTime()
                        )
                        .map((log) => (
                            <Timeline.Item key={log.log_id} dot={getIcon(log.action_type)}>
                                <div
                                    style={{
                                        backgroundColor: '#fff',
                                        padding: 16,
                                        borderRadius: 8,
                                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                                    }}
                                >
                                    <Space direction="vertical" size="small" style={{ width: '100%' }}>
                                        <Title level={5} style={{ margin: 0 }}>
                                            {log.action_type.toUpperCase()}{' '}
                                            <Tag color={
                                                log.action_type === 'created'
                                                    ? 'green'
                                                    : log.action_type === 'updated'
                                                        ? 'blue'
                                                        : 'red'
                                            }>
                                                {log.action_type}
                                            </Tag>
                                        </Title>
                                        <Text>{log.description}</Text>
                                        <Divider style={{ margin: '8px 0' }} />
                                        <Text type="secondary">
                                            {new Date(log.created_at).toLocaleString()}
                                        </Text>
                                        {log.employee_name && (
                                            <Text type="secondary">Employee: {log.employee_name}</Text>
                                        )}
                                        {/* {(log.old_value || log.new_value) && (
                                            <Collapse
                                                ghost
                                                style={{ marginTop: 8 }}
                                                expandIconPosition="right"
                                            >
                                                {log.old_value && (
                                                    <Panel header="Old Value" key="1">
                                                        <Descriptions column={1} bordered size="small">
                                                            {Object.entries(safeParseJson(log.old_value) || {}).map(([key, value]) => (
                                                                <Descriptions.Item label={key} key={key}>
                                                                    {typeof value === 'object' ? JSON.stringify(value) : String(value)}
                                                                </Descriptions.Item>
                                                            ))}
                                                        </Descriptions>
                                                    </Panel>
                                                )}
                                                {log.new_value && (
                                                    <Panel header="New Value" key="2">
                                                        <Descriptions column={1} bordered size="small">
                                                            {Object.entries(safeParseJson(log.new_value) || {}).map(([key, value]) => (
                                                                <Descriptions.Item label={key} key={key}>
                                                                    {typeof value === 'object' ? JSON.stringify(value) : String(value)}
                                                                </Descriptions.Item>
                                                            ))}
                                                        </Descriptions>
                                                    </Panel>
                                                )}
                                            </Collapse>
                                        )} */}
                                    </Space>
                                </div>
                            </Timeline.Item>
                        ))}
                </Timeline>
            )}
        </Drawer>
    );
};

export default AssetLogDrawer;
